module.exports = __webpack_public_path__ + "img/Picture19.cbc7402a.png";